import { render, staticRenderFns } from "./tt-account.vue?vue&type=template&id=b27812aa"
import script from "./tt-account.vue?vue&type=script&lang=js"
export * from "./tt-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports